import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronLeftIcon = createIcon(
  <polyline points="15 18 9 12 15 6" />,
  'ChevronLeftIcon'
);
